/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Flex, Box, Image, Text, HStack, Button } from '@chakra-ui/react';
import Tooltips from './Tooltips';

interface Props {
  data: any;
  phoneWidth: number;
}

const PromotionalBannersCarousel: React.FC<Props> = ({ data, phoneWidth }) => {
  const padding = 4;

  const [height, setHeight] = useState('160px');
  const [aspectRatio, setAspectRatio] = useState('1');
  const [iconBorder, setIconBorder] = useState('');

  useEffect(() => {
    if (data.size === 'medium') {
      setHeight('150px');
    } else if (data.size === 'small') {
      setHeight('90px');
    } else if (data.size === 'icon') {
      setHeight('60px');
      setIconBorder('50px');
    }
    if (data.type === 'vertical') {
      setAspectRatio('0.8');
    } else if (data.type === 'horizontal') {
      setAspectRatio('16 / 9');
    } else if (data.type === 'vertical_taller') {
      setAspectRatio('0.55');
    }
  }, []);

  return (
    <Box
      position="relative"
      w={phoneWidth - 8}
      _hover={{ bg: 'gray.200' }}
      backgroundColor="gray.100"
      borderRadius="6px"
      transition="150ms ease"
      p={`${padding}px`}
    >
      {data?.name ? (
        <>
          <Flex align="center" px={4}>
            <Text fontWeight="bold" fontSize="lg" mr={2}>
              {data?.name}
            </Text>
            <Tooltips data={data} />
          </Flex>
          {!!data?.description && (
            <Text fontSize="xs" color="gray.400" px={4}>
              {data.description}
            </Text>
          )}
        </>
      ) : (
        <Flex position="absolute" left={2} top={1}>
          <Tooltips data={data} />
        </Flex>
      )}
      <HStack overflow="auto" mt={4}>
        {data?.items?.map((banner: any) => (
          <Flex
            flexDir="column"
            align="center"
            flex="none"
            key={banner?.id}
            p={1}
            backgroundColor={banner.background_color ?? ''}
          >
            {banner?.file?.url && (
              <Image
                h={height}
                borderRadius={iconBorder ?? '6px'}
                mb={2}
                src={banner.file.url}
                style={{ aspectRatio, objectFit: 'cover' }}
              />
            )}

            {banner?.reference_value && (
              <Box>
                <Text
                  style={{
                    position: 'absolute',
                    paddingTop: 5,
                    paddingLeft: 5,
                  }}
                >
                  Video
                </Text>
                <Image
                  h={height}
                  borderRadius={iconBorder ?? '6px'}
                  mb={2}
                  src="/placeholder_product.jpg"
                  style={{ aspectRatio, objectFit: 'cover' }}
                />
              </Box>
            )}

            {banner.image_description && (
              <Text
                style={{
                  position: 'absolute',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  height: '100%',
                  color: banner.text_color,
                }}
              >
                {banner.image_description}
              </Text>
            )}
            <Text fontSize="xs" color="gray.500">
              {banner?.name}
            </Text>
          </Flex>
        ))}
        <Flex flexDir="column" align="center" flex="none">
          <Image
            h={height}
            borderRadius={iconBorder ?? '6px'}
            borderWidth="2px"
            borderStyle="dashed"
            mb={2}
          />
          <Text fontSize="xs" color="gray.500">
            + Adicionar
          </Text>
        </Flex>
      </HStack>
      <Flex
        style={{
          width: '100%',
          flex: 1,
          justifyContent: 'center',
        }}
      >
        <Button
          style={{
            marginTop: 10,
            width: 'fit-content',
            backgroundColor: '#999999',
            color: 'white',
            borderRadius: 15,
            height: 35,
          }}
        >
          Nome da página
        </Button>
      </Flex>
    </Box>
  );
};

export default PromotionalBannersCarousel;
